import React from 'react';

import * as S from './styles';
import logoKarana from './karana.png';

function Footer() {
  return (
    <S.Footer>
      <img src={logoKarana} alt="Logo do Karana" />
    </S.Footer>
  );
}

export default Footer;
